function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { forwardRef } from 'react';
import IconMinusCircleFilled from '~icons/ant-design/minus-circle-filled';
import IconMinusCircleOutlined from '~icons/ant-design/minus-circle-outlined';
import { theme } from '@arc/frontend/ui-theme';

/**
 * Styles that position an element in the center of its parent
 * without affecting the layout of other elements.
 *
 * @todo Should this be moved to somewhere so that it can be reusable?
 */
const centeredAbsolute = ({
  width,
  height
}) => /*#__PURE__*/css({
  width,
  height,
  position: 'absolute',
  top: `calc(50% - ${height} / 2)`,
  left: `calc(50% - ${width} / 2)`
}, process.env.NODE_ENV === "production" ? "" : ";label:centeredAbsolute;");
const styles = {
  button: /*#__PURE__*/css({
    position: 'relative',
    width: '2rem',
    height: '2rem',
    '&:active': {
      filter: 'brightness(81%)'
    },
    '&[data-disabled=true]': /*#__PURE__*/css({
      color: theme.colors.action.disabledBackground,
      cursor: 'default',
      svg: /*#__PURE__*/css({
        color: theme.colors.action.disabledBackground
      }, process.env.NODE_ENV === "production" ? "" : ";label:svg;"),
      'svg:active': {
        filter: 'none'
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:--data-disabled-true-;")
  }, process.env.NODE_ENV === "production" ? "" : ";label:button;"),
  buttonSmall: process.env.NODE_ENV === "production" ? {
    name: "1h7ldow",
    styles: "width:1.25rem;height:1.25rem"
  } : {
    name: "eo1m7f-buttonSmall",
    styles: "width:1.25rem;height:1.25rem;label:buttonSmall;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  icon: /*#__PURE__*/css({
    color: theme.colors.palettes.delete.main
  }, centeredAbsolute({
    width: '28px',
    height: '28px'
  }), process.env.NODE_ENV === "production" ? "" : ";label:icon;"),
  iconSmall: /*#__PURE__*/css({
    color: theme.colors.palettes.delete.main
  }, centeredAbsolute({
    width: '20px',
    height: '20px'
  }), process.env.NODE_ENV === "production" ? "" : ";label:iconSmall;"),
  iconNormal: process.env.NODE_ENV === "production" ? {
    name: "i1ed5t",
    styles: "button:hover:not([data-disabled=true]) > &, button:focus-visible:not([data-disabled=true]) > &{display:none;}"
  } : {
    name: "1ty65ij-iconNormal",
    styles: "button:hover:not([data-disabled=true]) > &, button:focus-visible:not([data-disabled=true]) > &{display:none;};label:iconNormal;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  iconHoverFocus: process.env.NODE_ENV === "production" ? {
    name: "ztr3ac",
    styles: "display:none;button:hover:not([data-disabled=true]) > &, button:focus-visible:not([data-disabled=true]) > &{display:initial;}"
  } : {
    name: "o9j51c-iconHoverFocus",
    styles: "display:none;button:hover:not([data-disabled=true]) > &, button:focus-visible:not([data-disabled=true]) > &{display:initial;};label:iconHoverFocus;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
// eslint-disable-next-line @typescript-eslint/no-shadow
export const ButtonIconDelete = forwardRef(function ButtonIconDelete({
  small = false,
  ...props
}, ref) {
  return <button css={[styles.button, small && styles.buttonSmall, process.env.NODE_ENV === "production" ? "" : ";label:ButtonIconDelete;"]} type="button" {...props} ref={ref} data-testid={props.testid ?? 'button-icon-delete'}>
			<IconMinusCircleOutlined css={[styles.icon, small && styles.iconSmall, styles.iconNormal, process.env.NODE_ENV === "production" ? "" : ";label:ButtonIconDelete;"]} />

			<IconMinusCircleFilled css={[styles.icon, small && styles.iconSmall, styles.iconHoverFocus, process.env.NODE_ENV === "production" ? "" : ";label:ButtonIconDelete;"]} />
		</button>;
});